"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANUAL_FINISH_BOOKING_FEE_ORDER = void 0;
exports.MANUAL_FINISH_BOOKING_FEE_ORDER = {
    TRAVEL_NOT_FOUND: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'TRAVEL_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'A viagem selecionada para o pagamento de tarifa do booking não foi encontrada.',
        },
    },
    CLIENT_NOT_FOUND: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'CLIENT_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'O Cliente ao qual a viagem pertence não foi encontrado.',
        },
    },
    TRAVELER_NOT_FOUND: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'TRAVELER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'O viajante não foi encontrado.',
        },
    },
    BILLING_PROFILE_NOT_FOUND: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'BILLING_PROFILE_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'O perfil de cobrança não foi encontrado.',
        },
    },
    CARD_NOT_FOUND: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'CARD_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'O cartão de credito informado não foi encontrado em nosso sistema.',
        },
    },
    INVALID_FEE_OPTION: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'INVALID_FEE_OPTION',
        messageLangMap: {
            'PT-BR': 'A configuração do cleinte não permite o pagamento de fee individual.',
        },
    },
    FEE_ALREADY_BEEN_PAID: {
        usecase: 'MANUAL_FINISH_BOOKING_FEE_ORDER',
        type: 'FEE_ALREADY_BEEN_PAID',
        messageLangMap: {
            'PT-BR': 'A fee dessa viagem ja foi paga.',
        },
    },
};
